import { ISubjectDTO, IVictimDTO } from '../../../store/users/types'

const imageMessageStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  border: '1px solid #ccc',
  borderRadius: '10px',
}

const imageUploadRowStyle = {
  height: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: '25vh',
  maxHeight: '25vh',
  width: '25vh',
}

const getDefaulfFormValues = (type: 'victim' | 'subject') => {
  if (type === 'subject') {
    return {
      subject: {
        person_type: '',
        full_name: '',
        description: '',
        image: '',
      },
      custom_fields: undefined,
    } as unknown as ISubjectDTO
  }

  return {
    victim: {
      person_type: '',
      full_name: '',
      description: '',
      image: '',
    },
    custom_fields: undefined,
  } as unknown as IVictimDTO
}

export default {
  imageMessageStyle,
  imageUploadRowStyle,
  getDefaulfFormValues,
}
